module.exports = __webpack_public_path__ + "img/xmsb2.23cc1f51.png";